import { ApiError } from '../api/client';

export function periodErrorText(error: unknown): string {
  if (error instanceof ApiError && error.status === 409) {
    return 'Dit tijdvak overlapt met een ander tijdvak (of een pauze heeft nog lessen).';
  }
  if (error instanceof ApiError && error.status === 400) return 'Het begin moet voor het einde liggen.';
  return 'Er ging iets mis. Probeer het opnieuw.';
}
